import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import AuthService from '../../../services/auth.service';
export const changePassword = createAsyncThunk('auth/change-password', async (data) => {
    try {
        return await AuthService.changePassword(data);
    }
    catch (err) {
        return err.response;
    }
});
export const initialState = {
    changed: false,
    error: null,
    pending: false
};
export const slice = createSlice({
    name: 'passwordRecovery',
    initialState,
    reducers: {
        resetStatus: (state) => {
            state.changed = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(changePassword.fulfilled, (state, action) => {
            state.pending = false;
            if (action.payload.status === 200) {
                state.changed = true;
            }
            if (action.payload.status === 404) {
                state.error = action.payload.data.error;
            }
            if (action.payload.status === 400) {
                state.error = action.payload.data.details;
            }
        });
        builder.addCase(changePassword.rejected, (state, action) => {
            state.error = '';
            state.pending = false;
        });
        builder.addCase(changePassword.pending, (state) => {
            state.changed = false;
            state.error = '';
            state.pending = true;
        });
    }
});
export const { resetStatus } = slice.actions;
export default slice.reducer;
